import { number } from 'yup';

export const MAX_PAYOFF_AMOUNT = 1000000;

export const payoffAmountValidation = number()
  .max(MAX_PAYOFF_AMOUNT, 'Must be less than 1 million')
  .nullable(true)
  .required('Payoff amount is required');
